// frontend/src/api/keyRotation.js
import { apiFetch } from './index.js';

/** Super Admin: dry-run scan — count & verify all encrypted rows */
export const scanEncryptedRows = (token) =>
  apiFetch('/admin/key-rotation/scan', token);

/** Super Admin: list all key versions (metadata only, no key values) */
export const listKeyVersions = (token) =>
  apiFetch('/admin/key-rotation/keys', token);

/** Super Admin: generate a new Fernet key (no DB changes) */
export const generateNewKey = (token) =>
  apiFetch('/admin/key-rotation/generate', token, { method: 'POST' });

/**
 * Super Admin: atomically rotate all encrypted data to a new key.
 * @param {string} token
 * @param {string} newKey   - new Fernet key string
 * @param {string} [label]  - optional human-readable label
 */
export const rotateKey = (token, newKey, label) =>
  apiFetch('/admin/key-rotation/rotate', token, {
    method: 'POST',
    body: JSON.stringify({ new_key: newKey, label: label || undefined }),
  });
